import React, {useRef} from 'react';
import {ListingImg, ListingImgContainer, ListingImgStyleProps} from '../../../../hooks/components/location/ListingImgStyles';
import {constructListingImageUrl} from "../../../../util/ConstructImageUrlUtil";

interface LocationListItemListingImageProps extends ListingImgStyleProps {
  listingImageFileName: string;
}

const LocationListItemListingImage = (props: LocationListItemListingImageProps) => {
  const { listingImageFileName } = props;
  const imageRef = useRef<HTMLImageElement>(null);

  return <ListingImgContainer {...props}>
    <ListingImg src={constructListingImageUrl(listingImageFileName)} ref={imageRef} alt={'listing'} {...props} />
  </ListingImgContainer>
}

export default LocationListItemListingImage;
